// Reusable checkbox list for selecting groups.
export function GroupSelect({ groups, selected, onChange, testidPrefix = "group" }) {
  const toggle = (id) => {
    if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
    else onChange([...selected, id]);
  };

  if (!groups.length) {
    return <p className="text-xs text-gray-400">No groups yet. Create groups to control access.</p>;
  }

  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testidPrefix}-select`}>
      {groups.map((g) => {
        const on = selected.includes(g.id);
        return (
          <button key={g.id} type="button" onClick={() => toggle(g.id)} data-testid={`${testidPrefix}-option-${g.id}`}
            className={`text-xs font-semibold px-2.5 py-1 rounded-sm border transition-colors ${
              on ? "bg-[#002FA7] text-white border-[#002FA7]" : "bg-white text-gray-600 border-gray-300 hover:border-[#002FA7]"
            }`}>
            {g.name}
          </button>
        );
      })}
    </div>
  );
}
